import React, { useState, useEffect, useContext } from 'react';
import { Container, Header, BarChart, Select } from '@amzn/awsui-components-react-v3';
import { StateContext, DispatchContext } from './context/spotcp-context';
import { getJSClient } from '../js_client';
import { SPOTCP_HCP_COMPONENT_OPTIONS, STATUS_FINISHED, STATUS_LOADING } from './elements';
import '../../styles/spotcp.css';
import { SpotcpAsinHistogramInfo, InfoLink } from './info';
import logger from '../../utils/logging';
import ContextMenu from './custom/context-menu';

const componentOptions = [{ label: 'Product GMS', id: 'total' }].concat(SPOTCP_HCP_COMPONENT_OPTIONS);

const componentBarChartID = 'spot-components';

export const HistogramComponents = (props) => {
  let client;

  const { histogramData, request } = useContext(StateContext);
  const dispatch = useContext(DispatchContext);

  const [selectedComponent, setSelectedComponent] = useState(componentOptions[0]);
  const [barchartData, setBarchartData] = useState([]);
  const [chartStatus, setChartStatus] = useState([STATUS_LOADING]);
  const [xDomain, setXDomain] = useState([]);
  const [ymin, setYmin] = useState(null);
  const [ymax, setYmax] = useState(null);
  const [visibleSeries, setVisibleSeries] = useState([]);

  // effect
  useEffect(() => {
    client = getJSClient();
  });

  useEffect(() => {
    getBarchartData(selectedComponent.id);
  }, [histogramData]);

  // helper
  const setUpYaxisBound = (data) => {
    setYmax(Math.ceil(Math.max(...data)));
    setYmin(Math.floor(Math.min(...data)));
  }

  const generateData = (input, title) => {
    return {
      title,
      type: 'bar',
      data: input.map(d => ({
        x: d.binName,
        y: d.value,
      })),
      valueFormatter: (t) => '$' + t.toLocaleString('en-US'),
    }
  }

  const getBarchartData = (componentId) => {
    setChartStatus(STATUS_LOADING);
    if (histogramData) {
      let hcpDataFA = histogramData[`total|hcp_${componentId}|fa`];
      let hcpDataLA = histogramData[`total|hcp_${componentId}|la`];
      if (!hcpDataFA && !hcpDataLA) {
        client.runSpotcpAsinHistogramFaAndLa(dispatch, { ...request, component: componentId });
      } else if (!hcpDataFA && hcpDataLA) {
        logger.info('Histograme data query for LA is still running....');
      } else if (hcpDataFA && !hcpDataLA) {
        logger.info('Histograme data query for FA is still running....');
      } else if (hcpDataFA && hcpDataLA) {
        setXDomain(hcpDataFA.map(d => d.binName));
        setUpYaxisBound(hcpDataFA.map(d => d.value));
        let newBarchartData = [
          generateData(hcpDataFA, 'HCP component Per Unit (FA)'), 
          generateData(hcpDataLA, 'HCP component Per Unit (LA)'),
        ];
        setBarchartData(newBarchartData);
        setVisibleSeries(newBarchartData);
        setChartStatus(STATUS_FINISHED);
      } else {
        logger.debug('backend return weird partial data for component histogram.', histogramData);
      }
    }
  };

  const onSelectChanged = (e) => {
    setSelectedComponent(e.detail.selectedOption);
    getBarchartData(e.detail.selectedOption.id);
  };

  return (
    
    <Container
      className="custom-dashboard-container"
      header={
        <Header
          variant="h2"
          description=" Net variances vs. HCP Components per unit"
          info={<InfoLink onFollow={() => props.updateTools(<SpotcpAsinHistogramInfo />)} />}
          actions={
            <Select
              selectedOption={selectedComponent}
              options={componentOptions}
              onChange={onSelectChanged}
              filteringType="auto"
              className="spotcp-select"
            />
          }
        >
          ASIN Histogram
        </Header>
      }
    >
      <BarChart
        id={`${componentBarChartID}`}
        series={barchartData}
        xDomain={xDomain}
        yDomain={[ymin, ymax]}
        i18nStrings={{
          filterPlaceholder: 'Filter data',
          yTickFormatter: t =>
          Math.abs(t) < 1e3 ? t : (t / 1e3).toFixed() + "k"
        }}
        errorText="Error loading data."
        height={300}
        hideFilter
        loadingText="Loading chart"
        statusType={`${chartStatus}`}
        xScaleType="categorical"
        xTitle="Net Variances of Net CP"
        yTitle={`${selectedComponent.label} per unit amount`}
        visibleSeries={visibleSeries}
        onFilterChange={({detail}) => setVisibleSeries(detail.visibleSeries)}
      />
      <ContextMenu chartID={componentBarChartID} selectedComponentID={selectedComponent.id}/>
    </Container>
  );
};


// WEBPACK FOOTER //
// ./src/components/spotcp/histogram-components.jsx